import React from 'react';

import { EmptyCard } from '@weezevent/nacre';
import { EmptyError } from 'images';

export const TemplatesList = () => {
    return <EmptyCard image={EmptyError} subTitle="This page will be available soon!" title="Page under construction" />;
};
